export type PillLink = {
  title: string
}

/**
 * Titles in the order the links were added, not alphabetically, so the field
 * reads the way it will be published.
 */
export function linkTitles(links: PillLink[] | undefined): string[] {
  return (links || []).map((link) => link.title)
}
